function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.99,
    height: 9.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 4.87
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.74,
    width: 24.99,
    height: 22.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.75875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 20.775
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.81,
    width: 24.99,
    height: 26.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 44.864999999999995
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.92,
    width: 24.99,
    height: 28.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 72.125
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.32,
    width: 24.99,
    height: 36.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7766666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 104.74
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.16,
    width: 24.99,
    height: 41.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 143.76999999999998
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.38,
    width: 24.99,
    height: 43.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 186.01999999999998
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.66,
    width: 24.99,
    height: 45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 230.16
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.67,
    width: 24.99,
    height: 49.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 277.25
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 301.83,
    width: 24.99,
    height: 49.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 326.78
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.72,
    width: 24.99,
    height: 55.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 379.52500000000003
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.34,
    width: 24.99,
    height: 57.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 435.905
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.46,
    width: 24.99,
    height: 57.82,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 493.37
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.28,
    width: 24.99,
    height: 58.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 551.41
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.54,
    width: 24.99,
    height: 59.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.12375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 610.28
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.03,
    width: 24.99,
    height: 59.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.495,
    y: 670.015
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 0,
    width: 36.94,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.694
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.459999999999994,
    y: 21.985
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.93,
    y: 0,
    width: 37.03,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.445,
    y: 21.985
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.95,
    y: 0,
    width: 38.5,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.2,
    y: 21.985
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.46,
    y: 0,
    width: 38.58,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.75,
    y: 21.985
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.04,
    y: 0,
    width: 39.11,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.911
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.595,
    y: 21.985
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.15,
    y: 0,
    width: 41.27,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.895714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.785,
    y: 21.985
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.42,
    y: 0,
    width: 42.5,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.071428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.67,
    y: 21.985
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.93,
    y: 0,
    width: 43.4,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.63,
    y: 21.985
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.33,
    y: 0,
    width: 45.66,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.15999999999997,
    y: 21.985
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.99,
    y: 0,
    width: 46.8,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.39,
    y: 21.985
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.79,
    y: 0,
    width: 47.9,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.74,
    y: 21.985
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.69,
    y: 0,
    width: 49.84,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.281428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.61,
    y: 21.985
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.53,
    y: 0,
    width: 55.3,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.328333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.18,
    y: 21.985
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.83,
    y: 0,
    width: 55.74,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.7,
    y: 21.985
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.57,
    y: 0,
    width: 56.43,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.997272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.7850000000001,
    y: 21.985
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 43.97,
    width: 56.58,
    height: 43.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 65.91499999999999
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 87.86,
    width: 56.58,
    height: 44.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 110.3
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 132.74,
    width: 56.58,
    height: 47.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 156.59
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 180.44,
    width: 56.58,
    height: 48.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 204.47
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 228.5,
    width: 56.58,
    height: 50.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.164285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 253.575
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 278.64,
    width: 56.58,
    height: 50.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2057142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 303.86
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 329.08,
    width: 56.58,
    height: 53.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.468333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 355.89
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 382.7,
    width: 56.58,
    height: 58.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 411.98
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 441.27,
    width: 56.58,
    height: 79.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6579999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 481.16999999999996
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 521.06,
    width: 56.58,
    height: 88.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 565.4499999999999
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 609.85,
    width: 56.58,
    height: 90.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6579999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 654.9250000000001
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 43.97,
    width: 70.01,
    height: 75.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.364545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.57499999999999,
    y: 81.86
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.58,
    y: 43.97,
    width: 70.39,
    height: 75.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.731666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.775,
    y: 81.86
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.97,
    y: 43.97,
    width: 88.21,
    height: 75.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.825714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.075,
    y: 81.86
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.19,
    y: 43.97,
    width: 91.28,
    height: 75.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.83,
    y: 81.86
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.47,
    y: 43.97,
    width: 97.29,
    height: 75.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.115,
    y: 81.86
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.75,
    y: 43.97,
    width: 98.4,
    height: 75.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.95,
    y: 81.86
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.15,
    y: 43.97,
    width: 102.85,
    height: 75.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.5749999999999,
    y: 81.86
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 119.75,
    width: 113.4,
    height: 73.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.1275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.26999999999998,
    y: 156.26
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 192.77,
    width: 113.4,
    height: 81.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.26999999999998,
    y: 233.34500000000003
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 273.92,
    width: 113.4,
    height: 95.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.933333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.26999999999998,
    y: 321.72
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 369.52,
    width: 113.4,
    height: 129.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.26999999999998,
    y: 434.37
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.57,
    y: 499.22,
    width: 113.4,
    height: 200.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.900000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.26999999999998,
    y: 599.61
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.97,
    y: 119.75,
    width: 142.13,
    height: 169,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.03499999999997,
    y: 204.25
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.1,
    y: 119.75,
    width: 166.25,
    height: 169,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.113636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.225,
    y: 204.25
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.35,
    y: 119.75,
    width: 196.65,
    height: 169,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 42.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.6750000000001,
    y: 204.25
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.97,
    y: 288.75,
    width: 181.12,
    height: 201.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.874285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.53,
    y: 389.71
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.97,
    y: 490.68,
    width: 181.12,
    height: 209.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.53,
    y: 595.34
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.09,
    y: 288.75,
    width: 159.98,
    height: 270.33,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.08,
    y: 423.91499999999996
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.08,
    y: 288.75,
    width: 163.92,
    height: 270.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.319999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.0400000000001,
    y: 423.91499999999996
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.09,
    y: 559.08,
    width: 323.91,
    height: 140.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.486666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.045,
    y: 629.5400000000001
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.f0a26c92e557b8d9b2e13bfb0bc78474.svg";
export { ForwardRef as ReactComponent };